import { Banner, Emphasis, FormattedRelativeTime, Link, Stack } from '@customerio/pluma-components/react';
import { formatError } from '@/utils/format-error';
import {
  FCM_ERROR_CODES_URL,
  fcmDynamicErrorMessage,
  sortPushErrorsNewestFirst,
  type PushSettingsError,
} from '../utils/push-errors';

type PushErrorDescriptionProps = {
  error: PushSettingsError;
};

function PushErrorDescription({ error }: PushErrorDescriptionProps) {
  const dynamicMessage = fcmDynamicErrorMessage(error);

  return (
    <>
      {dynamicMessage == null ? (
        formatError(error, { type: 'push' })
      ) : (
        <>
          FCM INVALID_ARGUMENT: {dynamicMessage} Learn more about{' '}
          <Link href={FCM_ERROR_CODES_URL} variant="secondary" isExternal={true}>
            error codes for FCM failure conditions
          </Link>
          .
        </>
      )}{' '}
      <Emphasis size="sm">
        - <FormattedRelativeTime date={error.updated} />
      </Emphasis>
    </>
  );
}

export type PushConfigErrorsProps = {
  errors: readonly PushSettingsError[];
  onDismiss: (error: PushSettingsError) => void;
};

export function PushConfigErrors({ errors, onDismiss }: PushConfigErrorsProps) {
  if (errors.length === 0) {
    return null;
  }

  return (
    <Stack gap="150">
      {sortPushErrorsNewestFirst(errors).map((error, index) => (
        <Banner
          key={error.id}
          variant="critical"
          icon={null}
          onClose={() => onDismiss(error)}
          description={<PushErrorDescription error={error} />}
          data-test-push-config-error={index}
        />
      ))}
    </Stack>
  );
}
